import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function ratingData(data) {
    let page = data.page ? data.page : 0;
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return axios.post(`${url}/users/ratings/` + page, payload, options)
        .then(response => {
            return {
                ratingData: response.data
            };
        });
}

function proRetoucherRatingData(data) {
    let page = data.page ? data.page : 0;
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return axios.post(`${url}/users/pro-retoucher-ratings/` + page, payload, options)
        .then(response => {
            return {
                proRetoucherRatingData: response.data
            };
        });
}

function proRetoucherNotificationData(data) {
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return axios.post(`${url}/users/pro-retoucher-notification`, payload, options)
        .then(response => {
            return {
                proRetoucherNotificationData: response.data
            };
        });
}

function adminRatingData(data) {
    let page = data.page ? data.page : 0;
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return axios.post(`${url}/users/admin-ratings/` + page, payload, options)
        .then(response => {
            return {
                adminRatingData: response.data
            };
        });
}

function adminCommonRatingData(data) {
    let page = data.page ? data.page : 0;
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return axios.post(`${url}/users/admin-common-ratings/` + page, payload, options)
        .then(response => {
            return {
                adminCommonRatingData: response.data
            };
        });
}

function adminCommonRatingDataUsers(data) {
    let page = data.page ? data.page : 0;
    const payload = JSON.stringify(data);
    const options = {
        headers: {
            'Content-Type': 'application/json',
        }
    };

    return axios.get(`${url}/users/admin-common-ratings/users/` + page, payload, options)
        .then(response => {
            return {
                adminCommonRatingDataUsers: response.data
            };
        });
}


function financeData() {
    return axios.get(`${url}/users/retoucher-finance`)
        .then(response => {
            return {
                financeData: response.data
            };
        });
}


export default {
    ratingData,
    proRetoucherRatingData,
    proRetoucherNotificationData,
    adminRatingData,
    adminCommonRatingData,
    adminCommonRatingDataUsers,
    financeData
};

